import { inject } from '@angular/core';
import {
  callApiMethod,
  setError,
  setLoaded,
  setLoading,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import {
  AutomationActionType,
  AutomationContext,
  AutomationProducerContextDataMap,
} from '@kinet-open-network/shared/data-access/model';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import { AutomationsService } from '../services/automations.service';

export const AutomationsStore = signalStore(
  { protectedState: false },
  withResourceState(AutomationsService),
  withMethods((store, service = inject(AutomationsService)) => ({
    runAction: <T extends AutomationContext>(
      action: AutomationActionType,
      context: T,
      contextData: AutomationProducerContextDataMap[T],
      data?: Record<string, unknown>,
    ) => {
      patchState(store, setLoading());
      return callApiMethod(
        () => service.runAction(action, context, contextData, data),
        {
          next: () => patchState(store, setLoaded()),
          error: (err) => patchState(store, setError(err)),
        },
      );
    },
  })),
);
